module.exports = __webpack_public_path__ + "static/media/27.fa17cd8d.svg";